/**
 * Formats an ISO timestamp as "May 12, 14:32" for the saving status indicator.
 */
const pad2 = (n: number): string => (n < 10 ? '0' + n : '' + n);

/**
 * Formats an ISO timestamp as "May 12, 14:32" for the saving status indicator.
 */
export function formatSavedDate(iso: string): string {
  const date = new Date(iso);
  const month = date.toLocaleString('en-US', { month: 'short' });
  const day = date.getDate();
  return `${month} ${day}, ${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
}

